import React from 'react';
import { number, bool } from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import './FadeTransition.scss';

export default function FadeTransition(props) {
    return <CSSTransition {...props} classNames="fade-transition" />;
}

FadeTransition.propTypes = {
    in: bool,
    timeout: number,
};

FadeTransition.defaultProps = {
    in: false,
    timeout: 300,
};
